/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ItemDetailService } from '../services/itemdetail.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemDetailResponse, CustomFieldInfo } from '../model/itemdetailinfo';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { CustomerPreferenceService } from './../../../preference/customerpreference.service';
import { Observable } from 'rxjs';

declare var $: any;

@Component({
  selector: 'zsd-itemdetail',
  templateUrl: '../view/itemdetail.component.html',
  styleUrls: ['../view/itemdetail.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})


export class ItemDetailComponent implements OnInit {
  itemId: number;
  itemDetail: ItemDetailResponse = new ItemDetailResponse();
  customFieldInfo: CustomFieldInfo = new CustomFieldInfo();
  matrix = [];
  canCreateIncidents: boolean;
  canCreateChangeRequests: boolean;
  showOutage = false;
  customCategory;
  popupHeaderString;
  imagePath;
  itemSelectionRequired: number;


  constructor(public itemDetailService: ItemDetailService, private route: ActivatedRoute,
    public router: Router, public _DomSanitizer: DomSanitizer,
    public customerPreferenceService: CustomerPreferenceService) {
    this.router.events.subscribe(
      () => {
        if (this.router.url.includes('/outages')) {
          this.showOutage = true;
        }
      }
    );
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params['processIndexName']) {
        this.customCategory = params['processIndexName'];
        // this.localizeHeaderString();
      }
      if (params['itemId']) {
        this.itemId = params['itemId'];
      }
    });
    $('#zsd_modal_new_request').modal('show');
    this.customerPreferenceService
      .getPreferenceList()
      .subscribe((preference: CustomerPreferenceResponse) => {
        // privilege to check whether item is required, optional or hided
        this.itemSelectionRequired = preference.itemSelectionRequired;
        // privilege check for create an incident icon
        this.canCreateIncidents = preference.canCreateIncidents;
        // privilege check to create change request icon
        this.canCreateChangeRequests = preference.canCreateChangeRequests;
      });
    this.route.params.subscribe(params => {
      this.itemId = params['itemId'];
    });

    // fetching item Detail
    let itemDetailHTTP: Observable<ItemDetailResponse> = null;

    if (this.showOutage) {
      itemDetailHTTP = this.itemDetailService.getOutageItemDetail(this.itemId);
    } else {
      itemDetailHTTP = this.itemDetailService.getItemDetail(this.itemId);
    }

    itemDetailHTTP.subscribe(
      (itemDetailResponse: ItemDetailResponse) => {
        let chunkSize = 2;
        this.itemDetail = itemDetailResponse;
        let arr = this.itemDetail.customFields;
        let groups = arr.map(function (e, i) {
          return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
          console.log(e);
        });
        this.matrix = groups;
      },
    );
  }
  createIncident(itemDetail: ItemDetailResponse) {
    this.itemId = itemDetail.itemBasicInfo.itemId;
    this.customCategory = 'incident';
    this.resetModal();
    this.localizeHeaderString();
  }

  createChangeRequest(itemDetail: ItemDetailResponse) {
    this.itemId = itemDetail.itemBasicInfo.itemId;
    this.customCategory = 'change';
    this.resetModal();
    this.localizeHeaderString();
  }

  resetModal() {
    $('#zsd_modal_new_request .modal-header').css('display', 'inline-flex');
    $('#zsd_modal_new_request .modal-header').show();
    $('#zsd_modal_new_request').css('width', '100%');
    $('#zsd_modal_new_request').css('margin-left', '0');
    $('#request_success_msg').hide();
    $('#report_incident_row').show();
  }

  localizeHeaderString() {
    if (this.customCategory === 'incident') {
      this.popupHeaderString = 'NewRequest.incidentHeader';
      this.imagePath = 'img/createincidentheader.png';
    }
    if (this.customCategory === 'change') {
      this.popupHeaderString = 'NewRequest.changeRequestHeader';
      this.imagePath = 'img/createchangerequestheader.png';
    }
    if (this.customCategory === 'service') {
      this.popupHeaderString = 'NewRequest.serviceRequestHeader';
      this.imagePath = 'img/createservicerequestheader.png';
    }
  }

  resetCreateRequest() {
    this.customCategory = '';
  }
}
